<template>
  <div class="app">
    <Header v-if="globals.publicConfig && globals.publicConfig.website && globals.publicConfig.website.showHeader" />
    <!-- div class="backdrop" v-bind:class="(registrationModal ? 'active' : '')"></div>
    <div class="modal" v-if="registrationModal" v-bind:class="(registrationModal ? 'active' : '')" >
      <Registration />
    </div -->
    <router-view :key="$route.name + ($route.params.wikiname || '')"></router-view>
    <Footer/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';

export default {
    name: 'Site',
    data()
    {
        return {
            registrationModal: true,
        };
    },
    components:
    {
        Header,
        Footer,
    },
    computed:
    {
        ...mapGetters(['globals']),
    },
};
</script>
